export function WorkManagementLegend() {
  return (
    <g fill="var(--ga-text-muted)" className="font-mono text-[11px]">
      <text x={40} y={526}>
        OPEN: draft → ready → working → review
      </text>
      <text x={405} y={526}>
        WAIT: blocked
      </text>
      <text x={575} y={526}>
        CLOSED: accepted / cancelled
      </text>
    </g>
  );
}
